var React = require('react');

function CloseMenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill-current","d":"m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"}));
}

CloseMenuInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CloseMenuInline;

CloseMenuInline.default = CloseMenuInline;
